import { render } from "./BookingAppointmentTime.vue?vue&type=template&id=28c8b506&scoped=true&ts=true"
import script from "./BookingAppointmentTime.vue?vue&type=script&lang=ts"
export * from "./BookingAppointmentTime.vue?vue&type=script&lang=ts"

import "./BookingAppointmentTime.vue?vue&type=style&index=0&id=28c8b506&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c8b506"]])

export default __exports__